export const BODY_HEALTH_CHANGED_EVENT = 'vyv:body-health-changed';
export type BodyHealthChangeResource = 'body' | 'health';

/** Invalidates saved reads after a verified receipt or native import ACK; carries no row data. */
export function notifyBodyHealthChanged(ownerId: string, resource: BodyHealthChangeResource) {
  window.dispatchEvent(new CustomEvent(BODY_HEALTH_CHANGED_EVENT, { detail: { ownerId, resource } }));
}

export function isBodyHealthChangeFor(event: Event, ownerId: string | null, resource: BodyHealthChangeResource) {
  const detail = (event as CustomEvent<unknown>).detail;
  return !!ownerId && !!detail && typeof detail === 'object' && !Array.isArray(detail)
    && (detail as Record<string, unknown>).ownerId === ownerId
    && (detail as Record<string, unknown>).resource === resource;
}
